// extracted by mini-css-extract-plugin
export default {"allow_cookies":"allow_cookies___mvZhm","content":"content___xmhNz","text":"text___oH6N7","btn":"btn___rayEB"};